import { SEVERITY_LEVELS } from 'Util/constants'
import { Alert, AlertTitle } from '@mui/material'
import type { FallbackProps } from 'react-error-boundary'
import { t } from 'ttag'

const ErrorFallback = ({ error /*, resetErrorBoundary */ }: FallbackProps) => {
  return (
    <Alert severity={SEVERITY_LEVELS.ERROR}>
      <AlertTitle>{t`Error`}</AlertTitle>
      {error?.message}
    </Alert>
  )
}
export default ErrorFallback
